// ArenaDisplay.js

// import React...
import React, { Component } from 'react';

// ... and fullcalendar-reactwrapper.
import FullCalendar from 'fullcalendar-reactwrapper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux';

class RoomAdmin extends Component {
    constructor(props) {
        super(props);
        this.calendarRef = React.createRef();
        this.state = {
        eventSources:[
                {
                    url: 'https://beiseker.bookice.ca/api/v0/calendar',
                    type: 'GET'
                }
            ]
      };
      
    };

    componentDidMount() {
        if (!this.props.user) {
          this.props.history.push('/login');
        }
      }

    eventRender(event, element, view) {
        if (view.type === 'arenaDisplay') {
            var toInject = [];
            if (event.home_room) {toInject.push('Home: ' + event.home_room)} else {toInject.push('<nbsp/>')};
            if (event.away_room) {toInject.push('Away: ' + event.away_room)} else {toInject.push('<nbsp/>')};
            for (var i = 0; i < toInject.length; i++) {	               
                element.append('<td>'+toInject[i]+'</td>');	     
            }          
        }
    };
    

    handleEventClick(event) {
         this.props.history.push('/event/' + event.guid + '/rooms');
    }

    render() {
        return (
          <div id="example-component">
          <FontAwesomeIcon icon={this.state.fetchStatus}/>
          <FullCalendar
            class = 'arena-display'
                 id = "Room-Admin-View"
             header = {{
                left: '',
               center: 'title',
                right: 'prev,next,today'
            }}
            views = {{
                arenaDisplay: {
                  type: 'list',
                  duration: { days: 7 },
                  buttonText: 'Arena Display'
                }
            }}
            defaultView = 'arenaDisplay'
            contentHeight = 'auto'
            eventSources = {this.state.eventSources}
            eventRender = {this.eventRender.bind(this)}
            eventClick = {this.handleEventClick.bind(this)}
        />
          </div>
        );
      }
}

const mapStateToProps = state => ({
    cart: state.cart,
    user: state.user,
    alert: state.alert
  });
  
  export default connect(mapStateToProps)(RoomAdmin);


// WEBPACK FOOTER //
// ./src/components/RoomAdmin.js